import React, { useEffect, useState } from "react";
import IntegrationCard from "./IntegrationCard";
import HMRCImage from "../../../assets/Settings/Integrations/HMRC.png";
import Sumsub from "../../../assets/Settings/Integrations/Sumsub.png";
import DocuSign from "../../../assets/Settings/Integrations/DocuSign.png";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import SolicitorsRegulation from "../../../assets/Settings/Integrations/SolicitorsRegulation.png";
import ClioPage from "./Clio/ClioPage";
import { getIntegrationDetails } from "api";
import HmrcPage from "./Hmrc/HmrcPage";
import SumsubPage from "./Sumsub/SumsubPage";
import DocuSignPage from "./DocuSign/DocuSignPage";

const connections = [
  {
    name: "HMRC MTD VAT Submission",
    connected: false,
    image: HMRCImage,
    integrationType: "HMRCVat",
  },
  {
    name: "Solicitors Register data share",
    connected: false,
    image: SolicitorsRegulation,
    integrationType: "Verify365",
  },
  {
    name: "Sumsub ID verifications",
    connected: false,
    image: Sumsub,
    integrationType: "Sumsub",
  },
  {
    name: "DocuSign e-signing solutions",
    connected: false,
    image: DocuSign,
    integrationType: "DocuSign",
  },
];

const Integrations = (props) => {
  const [onShowModal, setOnShowModal] = useState();
  const [integrationData, setIntegrationData] = useState(connections);
  const getIntegrations = async () => {
    try {
      const response = await getIntegrationDetails();
      setIntegrationData((prevData) => {
        const result = [];
        prevData.map((item) => {
          response?.data?.data?.forEach((resItem) => {
            if (
              item.integrationType === resItem.integrationType &&
              resItem.show
            ) {
              let object = {
                ...item,
                ...resItem,
              };
              result.push(object);
            }
          });
        });
        return result;
      });
    } catch (error) { }
  };
  useEffect(() => {
    getIntegrations();
  }, []);

  return (
    <div className="h-100 overflow-auto p-3">
      <div className={`d-flex flex-wrap gap-3 gap-xxl-5 mb-3`}>
        {integrationData.map((connection, index) => (
          <IntegrationCard
            key={index}
            name={connection?.name}
            connectionStatus={connection?.connected}
            image={connection?.image}
            onShowModal={setOnShowModal}
            integrationType={connection?.integrationType}
          />
        ))}
      </div>
      {onShowModal && (
        <Dialog
          title={
            integrationData.filter(
              (item) => item.integrationType === onShowModal
            )[0]?.name
          }
          onClose={() => {
            setOnShowModal();
          }}
          className="dialog-md"
        >
          <div className={`container p-0`} style={{ height: "430px" }}>
            <div className="p-2">
              {onShowModal === "Clio" && (
                <ClioPage
                  connectionStatus={
                    integrationData.filter(
                      (item) => item.integrationType === "Clio"
                    )[0]?.connected
                  }
                  onClose={() => {
                    getIntegrations();
                  }}
                />
              )}
              {onShowModal === "HMRCVat" && (
                <HmrcPage
                  connectionStatus={
                    integrationData.filter(
                      (item) => item.integrationType === "HMRCVat"
                    )[0]?.connected
                  }
                  onClose={() => {
                    setOnShowModal();
                    getIntegrations();
                  }}
                />
              )}
              {onShowModal === "Sumsub" && (
                <SumsubPage
                  connectionStatus={
                    integrationData.filter(
                      (item) => item.integrationType === "Sumsub"
                    )[0]?.connected
                  }
                  onClose={() => {
                    // setOnShowModal();
                    getIntegrations();
                  }}
                />
              )}
              {onShowModal === "DocuSign" && (
                <DocuSignPage
                  connectionStatus={
                    integrationData.filter(
                      (item) => item.integrationType === "DocuSign"
                    )[0]?.connected
                  }
                  onClose={() => {
                    getIntegrations();
                  }}
                />
              )}
            </div>
          </div>
          <DialogActionsBar className="dialog-footer">
            <div className="dialog-footer d-flex justify-content-end">
              <Button
                className="common-btn bgBtnSecondary border-0 me-4"
                onClick={() => {
                  setOnShowModal();
                }}
              >
                Cancel
              </Button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};

export default Integrations;
